import { useGetAccounts } from '../../../api/lending/lapiHooks';
import { useSuspenseGetAccounts } from '../../../api/lending/lapiHooks.suspense';

const getANTFormalOffers = (
  accounts: ReturnType<typeof useGetAccounts>['accounts'],
) =>
  accounts?.accounts?.flatMap((account) => {
    if (account.product_type === 'iwocapay') return [];
    if (account.loan_offer_id !== account.latest_formal_offer?.offer_id) {
      if (!account.latest_formal_offer?.is_valid) return [];
      if (!account.latest_formal_offer?.available_cash) return [];
      return [account.latest_formal_offer];
    }
    return [];
  }) || [];

export const useGetANTFormalOffers = () => {
  const { accounts, loadingAccounts } = useGetAccounts();

  return {
    antFormalOffers: getANTFormalOffers(accounts),
    loadingANTFormalOffers: loadingAccounts,
  };
};

export const useSuspenseGetANTFormalOffers = () => {
  const { accounts } = useSuspenseGetAccounts();

  return { antFormalOffers: getANTFormalOffers(accounts) };
};
